$(document).bind('before_ready',function(){
	
	if( $('#soci .soci_border').children().length == 2 )
	{
		$('#soci').addClass('one_box');
	}
	
	
	
	
});